// [4.8.2026, 16:24:38] Änderung: Die Admin-Route `/admin/ruletexts` wurde ergänzt und mit der neuen Komponente `RuleTextsView` verknüpft. Der Zugriff erfordert Authentifizierung und Admin-Rechte.
import { createRouter, createWebHistory } from "vue-router";
import {useStore} from "@/store"; 

import WishInput from "@/views/user/WishInput.vue";
import WishOverview from "@/views/user/WishOverview.vue";

import PeriodView from "@/views/admin/PeriodView.vue";
import UserManagementView from "@/views/admin/UserManagementView.vue";
import NotificationView from "@/views/admin/NotificationView.vue";
import StatisticView from "@/views/admin/StatisticView.vue";
import WorksettingsView from "@/views/admin/WorksettingsView.vue";
import RuleTextsView from "@/views/admin/RuleTextsView.vue";

import AuthView from "@/views/oauth/AuthView.vue";
import WishList from "@/views/user/WishList.vue";
import NotLoggedIn from "@/views/oauth/NotLoggedIn.vue";
import {authReady} from "@/main";
import TemplateView from "@/views/user/TemplateView.vue";
import WunschdienstInfoView from "@/views/admin/WunschdienstInfoView.vue";
import VacationList from "@/views/user/VacationList.vue";
import VacationInput from "@/views/user/VacationInput.vue";
import HomeView from "@/views/user/HomeView.vue";
import PlanView from "@/views/user/PlanView.vue";

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: "/",
      name: "home",
      component: HomeView,
    },
    {
      path: "/wuensche",
      name: "wuensche",
      component: WishList,
      meta: { requiresAuth: true, requiresWDP: true },
    },
    {
      path: "/wunschdienst/:id",
      name: "wunschdienst",
      component: WishInput,
      meta: { requiresAuth: true, requiresWDP: true },
    },
    {
      path: "/urlaubswuensche",
      name: "urlaubswuensche",
      component: VacationList,
      meta: { requiresAuth: true, requiresUP: true },
    },
    {
      path: "/urlaubswunsch/:year",
      name: "urlaubswunsch",
      component: VacationInput,
      meta: { requiresAuth: true, requiresUP: true },
    },
    {
      path: "/wunschdienst/overview/:id",
      name: "wunschdienstOverview",
      component: WishOverview,
      meta: { requiresAuth: true, requiresWDP: true },
    },
    {
      path: "/templates",
      name: "templates",
      component: TemplateView,
      meta: { requiresAuth: true, requiresWDP: true },
    },
    {
      path: "/planview",
      name: "planview",
      component: PlanView,
      meta: { requiresAuth: true },
    },
    {
      path: "/admin/period",
      name: "period",
      component: PeriodView,
      meta: { requiresAuth: true, requiresAdmin: true},
    },
    {
      path: "/admin/usermanagement",
      name: "usermanagement",
      component: UserManagementView,
      meta: { requiresAuth: true, requiresAdmin: true},
    },
    {
      path: "/admin/wunschdienst/:wunschdienstId/:userId",
      name: "wunschdienstInfo",
      component: WunschdienstInfoView,
      meta: { requiresAuth: true, requiresAdmin: true},
    },
    {
      path: "/admin/notification",
      name: "notification",
      component: NotificationView,
      meta: { requiresAuth: true, requiresAdmin: true},
    },
    {
      path: "/admin/statistics",
      name: "statistics",
      component: StatisticView,
      meta: { requiresAuth: true, requiresAdmin: true},
    },
    {
      path: "/admin/worksettings",
      name: "worksettings",
      component: WorksettingsView,
      meta: { requiresAuth: true, requiresAdmin: true},
    },
    {
      path: "/admin/ruletexts",
      name: "ruletexts",
      component: RuleTextsView,
      meta: { requiresAuth: true, requiresAdmin: true},
    },
    {
      path: "/oauth/auth",
      name: "oauth-auth",
      component: AuthView,
    },
    {
      path: "/oauth/notLoggedIn",
      name: "notLoggedIn",
      component: NotLoggedIn,
    }
  ],
});


router.beforeEach(async (to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  const requiresAdmin = to.matched.some(record => record.meta.requiresAdmin);
  const requiresWDP = to.matched.some(record => record.meta.requiresWDP);
  const requiresUP = to.matched.some(record => record.meta.requiresUP);
  const store = useStore();
  
  if (requiresAuth) {
    
    await authReady; 
    const user = store.state.userData.user;
    const loggedIn = user === undefined ? undefined : user !== null
    const isAdmin = store.getters.isAdmin;
    const isWDP = store.getters.isWDP;
    const isUP = store.getters.isUP;
//    console.log("Requires", requiresAuth, requiresAdmin, requiresWDP, requiresUP)
    console.log("Rechte", isAdmin, isWDP, isUP, loggedIn, user)
    if (loggedIn) {
      if (requiresAdmin) {
        if (isAdmin) {
          next();
        } else {
          next({path: "/"});
        }
      } else if (requiresWDP) {
        if (isWDP || isAdmin) {
          next();
        } else {
          next({path: "/"});
        }
      } else if (requiresUP) {
        if (isUP || isAdmin) {
          next();
        } else {
          next({path: "/"});
        }
      } else {
        next();
      }
    } else {
      next({path: "/oauth/notLoggedIn"});
    }
  } else {
    next();
  }
});
export default router;
